import { observable } from "mobx"
import { ClientType } from "./type";
import { postMessage } from "../messager/post";
import { IClientHostOptions } from "Apps/shared/ClientHost/options";
import { requestAnimationFrameX } from "utils/requestAnimationFrame";


export interface IClientHostContext {
    
    classList?: any[];
    fill?: () => void;
    resizeTo?: ({ width, height }) => void;
    scrollTo?: ({ x, y }) => void;
    scrollToElement?: (selector, offset) => void;
    previewPhotos?: (idx, images) => void;
    showEventModal?: (id,code?) => void;
    setModalSize?: ({ width, height }) => void;
    close?: () => void;
    loaded?:()=> void;
}


export class DefaultHost implements IClientHostContext {
    constructor(public options) {

    }
    app = this.options.app;
    scrollToElement(selector, offset) {
        var element = $(selector).get(0);
        $('html,body').animate({ scrollTop: element.offsetTop - offset }, 200);
    }
}

class BaseEmbedHost {
    constructor(public options: IClientHostOptions) {
        if (options.autoHeight) {
            this._autoFill();
        }
    }
    last_height = 0;
    _autoFill() {
        requestAnimationFrameX(() => {
            var height = $("body").height();
            if (this.last_height != height) {
                this.setIFrameHeight(height);
            }
            this._loop && this._loop();
            this._autoFill();
        });
    }
    _loop;

    setIFrameHeight(height) {
        this.last_height = height;
        postMessage({
            frameId: this.options.frameId,
            type: "setIFrameHeight",
            data: {
                height
            }
        });
    }

    showEventModal(id, code?) {
        var data:any = { id };
        if (code) {
            data.code = code;
        }
        postMessage({
            frameId: this.options.frameId,
            type: "showEventModal",
            data: data
        });
    }

    setModalSize({ width, height }) {
        postMessage({
            frameId: this.options.frameId,
            type: "setModalSize",
            data: {
                width,
                height
            }
        });
    }

    loaded() {
        postMessage({
            frameId: this.options.frameId,
            type: "loaded",
            data: {}
        })
    }

    close() {
        postMessage({
            frameId: this.options.frameId,
            type: "close",
            data: {}
        });
    }

    scrollToElement(selector, offset) {
        var element = $(selector).get(0);
        if (element) {
            $('html,body').animate({ scrollTop: element.offsetTop - offset }, 200);
        }
    }
}

export class FacebookHost extends BaseEmbedHost implements IClientHostContext {
    page_id: string;
    constructor(public options: IClientHostOptions) {
        super(options);
        this.page_id == options.facebook.page_id;
    }
    setIFrameHeight(height) {
        height = Math.max(height, 800);
        if (this.options.preview) {
            super.setIFrameHeight(height);
        }
        else {
            var FB = window['FB'];
            if (FB && FB.Canvas) {
                FB.Canvas.setSize({
                    width: 810,
                    height: height
                });
                this.last_height = height;
            }
        }
    }

    @observable page_info: {
        clientWidth: number,
        clientHeight: number,
        scrollLeft: number,
        scrollTop: number,
        offsetTop: number,
        offsetLeft: number
    } = null;

    _loop = () => {
        var FB = window['FB'];
        if (FB && FB.Canvas) {
            FB.Canvas.getPageInfo((info) => {
                this.page_info = info;
            });
        }
    }
    scrollTop(val) {
        var FB = window['FB'];
        if (FB && FB.Canvas) {
            FB.Canvas.getPageInfo((info) => {
                FB.Canvas.scrollTo(0, val);
            });
        }
    }
    scrollToElement(selector) {
        var FB = window['FB'];
        if (FB && FB.Canvas) {
            FB.Canvas.getPageInfo((info) => {
                var top = $(selector).get(0).getBoundingClientRect().top;
                var offset_top = offset_top || 200;
                FB.Canvas.scrollTo(0, (top + info.offsetTop - offset_top));
            });
        }
    }
}

export class EmbedHost extends BaseEmbedHost implements IClientHostContext {
    constructor(public options) {
        super(options);
    }

    scrollToElement(selector, offset) {
        var element = $(selector).get(0);
        if (element) {
            this.scrollTop($(element).offset().top);
        }
    }

    scrollTop(value) {
        postMessage({
            frameId: this.options.frameId,
            type: "scrollTop",
            data: {
                top: value
            }
        });
    }

}

export class SplashHost extends EmbedHost implements IClientHostContext {
    classList = [];

    constructor(public options: IClientHostOptions) {
        super(options);
        if (!options.splash.show_footer) {
            this.classList.push("sp-hide-step2-footer");
        }
    }
    previewPhotos(idx, images) {
        postMessage({
            frameId: this.options.frameId,
            type: "previewImages",
            data: {
                index: idx,
                images: images
            }
        });

    }
}

export class CalendarHost extends BaseEmbedHost implements IClientHostContext {
    classList = [];

    constructor(public options: IClientHostOptions) {       
        super(options);
        this.classList.push(`sp-calendar-${options.calendar.theme.toLowerCase()}`);
    }
}
export class CardHost extends BaseEmbedHost implements IClientHostContext {
    constructor(public options) {
        super(options);
    }
}

export class MobileHost extends BaseEmbedHost implements IClientHostContext {
    constructor(public options) {
        super(options);

    }
}


export function createHostContext(options) {
    switch (options.type) {
        case ClientType.embed:
            return new EmbedHost(options);
        case ClientType.splash:
            return new SplashHost(options);
        case ClientType.mobile:
            return new MobileHost(options);
        case ClientType.calendar:
            return new CalendarHost(options);
        case ClientType.cards:
            return new CardHost(options);
        case ClientType.facebook:
            return new FacebookHost(options);
        default:
            return new DefaultHost(options);
    }
}


// WEBPACK FOOTER //
// ./src/Apps/shared/ClientHost/hosts.ts